import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { getPreviousRegistrationPath } from '@/features/auth/navigation/registration.navigation'

export function RegistrationBackButton() {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation('common')
  const previousPath = getPreviousRegistrationPath(location.pathname)

  if (!previousPath) return null

  return (
    <button
      aria-label={t('btn.back')}
      className="inline-flex h-9 w-28 shrink-0 whitespace-nowrap items-center justify-center gap-2 rounded-lg border border-brand-primary bg-white px-5 py-2 text-sm font-semibold text-brand-primary transition-colors hover:bg-[#eef7fc] focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-focus-ring"
      onClick={() => navigate(previousPath, { replace: true })}
      type="button"
    >
      <span>{t('btn.back')}</span>
    </button>
  )
}
